import { CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CreditCard } from "lucide-react";
import {
  getStatusVariant,
  getDocumentTypeVariant,
  getPaymentStatusVariant,
} from "../utils/prescription-variants";
import { DocumentsDropdown } from "./documents-dropdown";
import { PrescriptionOrder } from "../../types/prescription";

interface PrescriptionHeaderProps {
  prescription: PrescriptionOrder;
}

export function PrescriptionHeader({ prescription }: PrescriptionHeaderProps) {
  const tags = prescription.tags || [];
  const isNoShow = tags.includes("no_show");
  const hidePendingTagContext = tags.includes("no_prescription_needed") || isNoShow;
  const hidePendingStatusBadge =
    prescription.status === "PENDING" && hidePendingTagContext;
  const hidePendingPaymentStatusBadge =
    prescription.payment_status === "PENDING" && hidePendingTagContext;
  const shouldForceShowDocumentsDropdown =
    tags.includes("no_prescription") ||
    tags.includes("no_prescription_found") ||
    tags.includes("prescription_not_found");

  return (
    <CardHeader className="flex flex-row items-center justify-between">
      <div>
        <CardTitle className="text-xl">{prescription.user.full_name}</CardTitle>
        <CardDescription>
          {prescription.document_type || "Unknown Document Type"}
        </CardDescription>
      </div>
      <div className="flex gap-2 flex-wrap items-center">
        {prescription.document_type && (
          <Badge variant={getDocumentTypeVariant(prescription.document_type)}>
            {prescription.document_type}
          </Badge>
        )}
        {!hidePendingStatusBadge && (
          <Badge variant={getStatusVariant(prescription.status)}>
            {prescription.status}
          </Badge>
        )}
        {isNoShow && (
          <Badge variant="destructive">NO SHOW</Badge>
        )}
        {prescription.payment_status && !hidePendingPaymentStatusBadge && (
          <Badge variant={getPaymentStatusVariant(prescription.payment_status)}>
            <CreditCard className="h-3 w-3 mr-1" />
            {prescription.payment_status}
          </Badge>
        )}
        <DocumentsDropdown
          prescriptionId={prescription.id}
          prescriptionDriveUrl={prescription.prescription_drive_url}
          prescriptionDocId={prescription.prescription_id}
          orderSummaryDriveUrl={prescription.order_summary_drive_url}
          forceShow={shouldForceShowDocumentsDropdown}
        />
      </div>
    </CardHeader>
  );
}
